import _ from 'lodash';

import { reactiveVariables } from 'modules/common';



export function useLoadingOverlay({ loading }: { loading: boolean }) {
  const currentValue = reactiveVariables.showLoadingOverlay();
  if (loading !== currentValue) {
    _.defer(() => reactiveVariables.showLoadingOverlay(loading));
  }
}
